<template>
  <v-container>
    <v-row v-show="loading">
      <v-col cols="12" sm="12">
        <div class="text-center">
          <p>Converting exam data…</p>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <v-row v-show="loading === false" dense>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="autoGenerate"
            class="mx-2"
            v-on="on"
            color="primary"
            style="margin-left: 0 !important"
            >Auto Generate Exam</v-btn
          >
        </template>
        <span
          >1-click creation of questions Multiple Choice questions ONLY</span
        >
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="reset" class="mx-2" v-on="on" color="primary"
            >Reset</v-btn
          >
        </template>
        <span>Undo all changes and restart with existing uploaded file</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="checkExam" class="mx-2" v-on="on" color="primary"
            >Export MoodleXML File</v-btn
          >
        </template>
        <span
          >Export questions into MoodleXML file which can be imported into
          eClass</span
        >
      </v-tooltip>
      <v-dialog v-model="answerDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">
          Incomplete
        </v-card-title>
        <v-card-text>
          You are missing correct answers for some of your questions - please set at least 1 correct answer for every question and try again.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="answerDialog = false">
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-row>
    <v-row v-show="loading === false">
      <v-col cols="12" sm="3" md="3">
        <v-text-field
          v-model="examPrefix"
          label="Question Naming Prefix"
          hint="questions will be named <prefix>-question#"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-show="loading === false">
      <v-col class="d-flex" cols="10" sm="6">
        <v-select
          v-model="qSelected"
          :items="qtypes"
          label="Question Type"
          dense
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="2" sm="6">
        <v-btn @click="addQuestion" class="mx-2" color="primary"
          >Add Question</v-btn
        >
      </v-col>
      <v-col class="d-flex" cols="10" sm="6">
        <v-text-field
          v-model="newToken"
          label="Exam Token"
          hint="Add a custom token"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="2" sm="6">
        <v-btn @click="addToken" class="mx-2" color="primary">Add Token</v-btn>
      </v-col>
      <v-col>
        <v-switch
          v-model="showRemoved"
          :label="`Show removed tokens`"
        ></v-switch>
        <v-switch
          v-model="shuffleAllMC"
          @click="toggleAllShuffleMC()"
          :label="`Shuffle all MC answers`"
        ></v-switch>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="ml-3 mr-2" v-on="on" @click="addNextXAnswers(3)">
              <v-icon small>mdi-format-list-checks</v-icon> +3
            </v-btn>
          </template>
          <span>Add next 3 tokens as possible answers</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="mx-2" v-on="on" @click="addNextXAnswers(4)">
              <v-icon small>mdi-format-list-checks</v-icon> +4
            </v-btn>
          </template>
          <span>Add next 4 tokens as possible answers</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="mx-2" v-on="on" @click="addNextXAnswers(5)">
              <v-icon small>mdi-format-list-checks</v-icon> +5
            </v-btn>
            </template>
          <span>Add next 5 tokens as possible answers</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="mx-2" v-on="on" @click="addNextXAnswers(6)">
              <v-icon small>mdi-format-list-checks</v-icon> +6
            </v-btn>
          </template>
          <span>Add next 6 tokens as possible answers</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <!-- <v-row v-show="preview">
      <v-col cols="12" sm="12">
        <v-col cols="12" sm="12">
          <v-textarea
          name="xml"
          label="Preview"
          :value="xmlFile"

        ></v-textarea>
        </v-col>
      </v-col>
    </v-row> -->
    <v-row v-show="loading === false" dense>
      <v-col cols="12" sm="6">
        <v-virtual-scroll
          :items="filteredTokens"
          height="800"
          :item-height="120"
          :class="themeClass"
        >
          <template v-slot:default="{ item }">
            <v-card class="mb-1" :key="item.index">
              <v-card-text>
                <v-text-field
                  :disabled="!item.active"
                  v-model="item.value"
                  hide-details="auto"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <template v-if="item.active">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="error"
                        x-small
                        v-on="on"
                        @click="removeToken(item)"
                      >
                        <v-icon>mdi-minus-box</v-icon>
                      </v-btn>
                    </template>
                    <span>Discard this text</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        v-on="on"
                        @click="addQuestionText(item)"
                        style="margin-right: 16px"
                      >
                        <v-icon>mdi-plus-box</v-icon>
                      </v-btn>
                    </template>
                    <span>Add question</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        v-on="on"
                        @click="addExtraText(item)"
                        style="margin-right: 16px"
                      >
                        <v-icon>mdi-playlist-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Append text to current active question</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        v-on="on"
                        @click="addAnswer(item)"
                      >
                        <v-icon>mdi-format-list-checks</v-icon>
                      </v-btn>
                    </template>
                    <span>Add as possible answer</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        v-on="on"
                        @click="restoreToken(item)"
                      >
                        <v-icon>mdi-restore</v-icon>
                      </v-btn>
                    </template>
                    <span>Restore Token</span>
                  </v-tooltip>
                </template>
              </v-card-actions>
            </v-card>
            <!-- </v-list-item> -->
          </template>
        </v-virtual-scroll>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card
          class="mb-1"
          v-bind:color="question.selected"
          v-for="(question, index) in reverseExamQuestions"
          :key="question.index"
        >
          <v-card-title
            >Question {{ reverseExamQuestions.length - index }}</v-card-title
          >
          <v-card-subtitle>{{ question.type }}</v-card-subtitle>
          <v-card-text @click="select({ question, index })">
            <p v-if="question.type === 'multichoice' || question.type === 'mc'">
              <v-icon
                v-if="question.shuffle === true"
                @click="toggleShuffleMC(question)"
                >mdi-checkbox-marked</v-icon
              >
              <v-icon v-else @click="toggleShuffleMC(question)"
                >mdi-checkbox-blank-outline</v-icon
              >
              Shuffle answers
            </p>
            <p v-for="(pre, preIndex) in question.pre" :key="preIndex">
              {{ pre }}
            </p>
            <p class="font-weight-black">{{ question.text }}</p>
            <p v-for="(post, postIndex) in question.post" :key="postIndex">
              {{ post }}
            </p>
            <v-list :style="[question.showRequired ? {'border': 'solid red 1px'} : {'border': 'none'}]">
              <v-list-item
                v-for="(answer, answerIndex) in question.answers"
                :key="answerIndex"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon
                    v-if="answer.percent > 0"
                    @click="toggleAnswer(question, answer)"
                    >mdi-checkbox-marked</v-icon
                  >
                  <v-icon v-else @click="toggleAnswer(question, answer)"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                </v-list-item-icon>
                <v-list-item-content @click="toggleAnswer(question, answer)">
                  <v-list-item-title
                    :class="[answer.percent > 0 ? 'green--text' : '']"
                    v-text="answer.text"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn
              icon
              color="error"
              x-small
              @click="resetQuestion(question, index)"
            >
              <v-icon>mdi-minus-box</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { autoGenerateExam, MoodleXMLFromQuiz } from "@/libs";
import { mapState, mapGetters } from "vuex";
import { filter } from "lodash";

const fs = require("fs");
export default {
  props: {
    loading: Boolean,
  },
  data: () => ({
    builder_state: {
      current_question: 0,
    },
    finalExam: {
      name: "",
      questions: [],
    },
    tokens: null,
    qtypes: [
      {
        text: "Multiple Choice",
        value: "multichoice",
      },
      {
        text: "Short Answer",
        value: "shortanswer",
      },
      {
        text: "Numerical",
        value: "numerical",
      },
      {
        text: "True/False",
        value: "truefalse",
      },
      {
        text: "Essay",
        value: "essay",
      },
      {
        text: "Description",
        value: "description",
      },
    ],
    showRemoved: false,
    shuffleAllMC: false,
    newToken: "",
    examPrefix: "",
    qSelected: "multichoice",
    xmlFile: null,
    answerDialog: false,
  }),
  mounted() {
    this.fetchDataFromVuex();
  },
  computed: {
    ...mapState(['examId']),
    ...mapGetters(['getExamTokens', 'getExam']),
    answerClass(answer) {
      if (answer.percent > 0) {
        return "red--text";
      } else {
        return "";
      }
    },
    filteredTokens() {
      const that = this;
      return filter(this.tokens, (value) => {
        return (that.showRemoved && value.removed) || value.active;
      });
    },
    reverseExamQuestions() {
      return this.finalExam.questions.slice().reverse();
    },
    themeClass() {
      return this.$vuetify.theme.dark? 'dark' : 'light';
    },
  },
  watch: {
    examPrefix: function (val) {
      this.finalExam.name = val;
    },
    finalExam: {
      deep: true,
      handler() {
        this.$store.commit('setExam', this.finalExam);
      }
    }, 
    tokens: {
      deep: true,
      handler() {
        this.$store.commit('setExamTokens', this.tokens);
      }
    }
  },
  methods: {
    toggleAnswer: function (question, answer) {
      if (question.type === 'truefalse' &&
          (question.answers[0].percent + question.answers[1].percent) > 0) {
        question.answers[0].percent = !(question.answers[0].percent) * 100;
        question.answers[1].percent = !(question.answers[1].percent) * 100;
      } else {
        if (answer.percent === 0) {
          answer.percent = 100;
        } else {
          answer.percent = 0;
        }
      }

      
    },
    toggleShuffleMC: function (question) {
      if (question.shuffle === true) {
        question.shuffle = false;
        this.shuffleAllMC = false;
      } else {
        question.shuffle = true;
      }
    },
    toggleAllShuffleMC: function () {
      this.finalExam.questions.forEach((question) => {
        if (question.type === "multichoice" || question.type === "mc") {
          if (this.shuffleAllMC) {
            question.shuffle = true;
          } else {
            question.shuffle = false;
          }
        }
      });
    },
    select: function (item) {
      if (this.finalExam.questions[this.builder_state.current_question]) {
        this.finalExam.questions[this.builder_state.current_question].selected =
          "#1e1e1e";
      }
      this.builder_state.current_question =
        this.finalExam.questions.length - item.index - 1;
      this.finalExam.questions[this.builder_state.current_question].selected =
        "#333333";
    },
    autoGenerate: function () {
      let result = autoGenerateExam(this.tokens);
      this.tokens = result.original;
      this.finalExam = result.exam;
    },
    reset: function () {
      this.finalExam = {
        questions: [],
        name: "",
      };
      this.builder_state.current_question = 0;
      this.tokens.forEach((token) => {
        token.active = true;
        token.hidden = false;
      });
    },
    fetchDataFromVuex: function () {
      this.tokens = JSON.parse ( JSON.stringify ( this.getExamTokens ) );
      this.finalExam = JSON.parse ( JSON.stringify ( this.getExam ) );
    },
    resetQuestion: function (question, index) {
      this.finalExam.questions[
        this.finalExam.questions.length - index - 1
      ].tokens.forEach((token) => {
        this.tokens[token].active = true;
      });

      this.finalExam.questions.splice(
        this.finalExam.questions.length - index - 1,
        1
      );
      if (
        this.builder_state.current_question >= this.finalExam.questions.length
      ) {
        this.builder_state.current_quesiton =
          this.finalExam.questions.length - 1;
      } else if (this.builder_state.current_question < 0) {
        this.builder_state.current_question = 0;
      }
    },
    addToken: function () {
      if (this.newToken) {
        let tokenObjectArray = [
          {
            value: this.newToken,
            index: 0,
            active: true,
            hidden: false,
          },
        ];
        for (let i = 0; i < this.tokens.length; i += 1) {
          this.tokens[i].index += 1;
        }
        this.tokens = [...tokenObjectArray, ...this.tokens];
        this.newToken = "";
      }
    },
    addQuestion: function () {
      if (this.finalExam.questions.length === 0) {
        this.finalExam.questions.push(this.createQuestion());
      } else {
        if (
          this.builder_state.current_question !==
          this.finalExam.questions.length - 1
        ) {
          this.finalExam.questions.splice(
            this.builder_state.current_question + 1,
            0,
            this.createQuestion()
          );
          this.builder_state.current_question++;
        } else {
          this.finalExam.questions.push(this.createQuestion());
          this.builder_state.current_question++;
        }
      }
    },
    addQuestionText: function (token) {
      if (this.finalExam.questions.length === 0) {
        this.finalExam.questions.push(this.createQuestion());
      }
      if (!this.finalExam.questions[this.builder_state.current_question]) {
        this.builder_state.current_question =
          this.finalExam.questions.length - 1;
      }
      if (
        this.finalExam.questions[this.builder_state.current_question].text ===
        ""
      ) {
        this.finalExam.questions[
          this.builder_state.current_question
        ].text = this.cleanText(token.value);
        this.tokens[token.index].active = false;
        this.finalExam.questions[
          this.builder_state.current_question
        ].tokens.push(token.index);
      } else {
        this.addQuestion();
        this.finalExam.questions[
          this.builder_state.current_question
        ].text = this.cleanText(token.value);
        this.tokens[token.index].active = false;
        this.finalExam.questions[
          this.builder_state.current_question
        ].tokens.push(token.index);
      }
    },
    removeToken: function (token) {
      this.tokens[token.index].active = false;
      this.tokens[token.index].removed = true;
    },
    restoreToken: function (token) {
      this.tokens[token.index].active = true;
      this.tokens[token.index].removed = false;
    },
    addAnswer: function (token) {
      if (this.finalExam.questions.length === 0) {
        this.finalExam.questions.push(this.createQuestion());
      }
      if (
        this.finalExam.questions[this.builder_state.current_question].type ===
        "multichoice"
      ) {
        this.finalExam.questions[
          this.builder_state.current_question
        ].answers.push({ text: this.cleanText(token.value), percent: 0 });
      } else if (
        this.finalExam.questions[this.builder_state.current_question].type ===
        "numerical"
      ) {
        let reg = /[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/g;
        let number = token.value.match(reg);
        if (number.length > 0) {
          this.finalExam.questions[
            this.builder_state.current_question
          ].answers.push({ text: number[0], percent: 100 });
        } else {
          this.finalExam.questions[
            this.builder_state.current_question
          ].answers.push({ text: token.value, percent: 100 });
        }
      } else if (
        this.finalExam.questions[this.builder_state.current_question].type ===
        "truefalse"
      ) {
        // Do nothing.  T/F can only have the default 'True' and 'False' as answers.
        return;
      } else {
        this.finalExam.questions[
          this.builder_state.current_question
        ].answers.push({ text: token.value, percent: 0 });
      }
      this.tokens[token.index].active = false;
      this.finalExam.questions[this.builder_state.current_question].tokens.push(
        token.index
      );
    },
    addNextXAnswers: function(count) {
      let answersPushed = 0;
      for (let i = 0; i < this.tokens.length && answersPushed < count; i++) {
        if (this.tokens[i].active) {
          this.addAnswer(this.tokens[i]);
          answersPushed++;
        }
      }
    },
    addExtraText: function(token) {
      if(this.finalExam.questions.length === 0) {
        this.finalExam.questions.push(this.createQuestion());
      }
      if (
        this.finalExam.questions[this.builder_state.current_question].text ===
        ""
      ) {
        this.finalExam.questions[
          this.builder_state.current_question
        ].pre.push(token.value);
        this.tokens[token.index].active = false;
        this.finalExam.questions[
          this.builder_state.current_question
        ].tokens.push(token.index);
      } else {
        this.finalExam.questions[
          this.builder_state.current_question
        ].post.push(token.value);
        this.tokens[token.index].active = false;
        this.finalExam.questions[
          this.builder_state.current_question
        ].tokens.push(token.index);
      }
    },
    createQuestion: function () {
      if (this.finalExam.questions[this.builder_state.current_question]) {
        this.finalExam.questions[
          this.builder_state.current_question
        ].selected = false;
      }

      let answers = [];
      if (this.qSelected === 'truefalse') {
        answers = [{text:'True'},{text:'False'}];
      }

      return {
        selected: "#333333",
        pre: [],
        post: [],
        type: this.qSelected,
        text: "",
        answers: answers,
        tokens: [],
      };
    },
    cleanText: function (text) {
      const prefix = /^\s*\*?([A-Za-z]\.)?([0-9]+\.)?\s*([A-Za-z]\.)?([0-9]*\.)?\s+\*?\s?/g;
      let clean = text.replace(prefix, "");
      return clean;
    },
    checkExam: function () {
      let answersMissing = false;

      this.finalExam.questions.forEach((question) => {
        if (question.type === "multichoice" || question.type === "mc"){
          let correctFound = false;
          for(var i = 0; i < question.answers.length; i++) {
            if (question.answers[i].percent > 0) {
              correctFound = true;
            }
          }
          if (!correctFound) {
            answersMissing = true;
            question.showRequired = true;
          } else {
            question.showRequired = false;
          }
        }
      });

      if (answersMissing) {
        this.answerDialog = true;
      } else {
        this.saveXml();
      }
    },
    saveXml: async function () {
      let element = document.createElement("a");
      const xml = await MoodleXMLFromQuiz(this.finalExam, this.examPrefix, this.examId);
      this.$emit('xmlgenerate', {
        xml,
        finalexam: this.finalExam,
      });
      element.setAttribute(
        "href",
        "data:text/xml;charset=utf-8," +
          encodeURIComponent(
            xml
          )
      );
      element.setAttribute("download", "MoodleQuiz.xml");
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      // this.setFocus();
    },
  },
};
</script>
<style scoped>
.light::-webkit-scrollbar {
  width: 15px;
}

.light::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

.light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
  border-radius: 7px;
}

.light::-webkit-scrollbar-thumb:hover {
  background: black;
}

.dark::-webkit-scrollbar {
  width: 15px;
}

.dark::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.dark::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.dark::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>